<template>
  <v-dialog v-model='showModal' persistent max-width='800' :overlay="true">
    <v-card v-if="mod">
      <v-toolbar tabs>
        <v-toolbar-title id='title'>{{ mod.name }} Description</v-toolbar-title>
      </v-toolbar>
      <v-textarea ref="description" v-model="mod.description" placeholder="Insert description" auto-grow hide-details full-width></v-textarea>
      <v-toolbar tabs>
        <v-spacer></v-spacer>
        <v-btn class='black--text' flat @click.native='$emit("hide-modal")'>Close</v-btn>
      </v-toolbar>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    mod: Object
  },
  watch: {
    showModal(val) {
      if(val) {
        this.$nextTick(() => this.$refs.description.focus());
      } 
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Workspace/Menus/EditDescriptionModal.vue